export default __webpack_public_path__ + "static/media/order-step4.c9b46418.svg";